import { createSelector } from '@ngrx/store';
import { getHistoryOrderByOrderGUID } from '../getHistoryOrderByOrderGUID';

export const getHistoryOrderVoucher = (orderGUID: string) =>
    createSelector(getHistoryOrderByOrderGUID(orderGUID), (order) => (order?.data?.ActivatedVouchers?.length ? order.data?.ActivatedVouchers[0] : null));
